let linkActiveClass = "active";

export default {
  loginRoute: { name: "auth" },
  requiresGuestRedirect: "/",
  requiresUserRedirect: "/user/login",
  useI18n: true,
  linkActiveClass: linkActiveClass,
};
